import loanAgainstCarIcon from "../images/loan-against-car.svg";
import personalLoanIcon from "../images/personal-loan.svg";

export const LOAN_TYPE_ICONS = [loanAgainstCarIcon, personalLoanIcon];

export const SF_CMS_IMAGE_SLUGS = {
    BANNER_HERO: "banner_hero",
    STEPS_BANNER: "steps_banner",
    LOAN_TYPE_PL: "pl",
    LOAN_TYPE_LAC: "lac",
    LENDING_PARTNER_PREFIX: "partner"
};

export const LOAN_TYPE_IMAGES = [
    SF_CMS_IMAGE_SLUGS.LOAN_TYPE_LAC,
    SF_CMS_IMAGE_SLUGS.LOAN_TYPE_PL
];

export const DEFAULT_SF_LANDING_SOURCE = "SF_Landing_Page";

export const SF_LANDING_OG_URL =
  "https://media.cars24.com/cars24/seo/static/loans_tailored.png";
